import client from './client';
import type { CdnPackages, CdnQuota } from '../types/cdn';

/** Квота обхода белых списков текущего юзера (JWT). 401/500 обрабатывает вызывающий. */
export async function getCdnQuota(): Promise<CdnQuota | null> {
  const { data } = await client.get('/cdn/quota');
  return data || null;
}

/** Публичный прайс докупки: цена за ГБ, квота триала и список пакетов. */
export async function getCdnPackages(): Promise<CdnPackages> {
  const { data } = await client.get('/cdn/packages');
  // Пустой список бекенд может отдать как null — нормализуем, чтобы .map не падал
  return { ...data, packages: data?.packages ?? [] };
}
